import Yup from '@utils/Yupi18n';

const patternINE = /[A-Z|a-z]{6}[0-9]{8}[A-Z|a-z]{1}[0-9]{3}/;

const CompromisoAddPublicSchema = Yup.object({
  account: Yup.object().shape({
    // Username: Yup.string().phone().min(10).max(10).required().label('Celular'),
    Password: Yup.string()
      .required()
      .min(8)
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/,
        'La contraseña debe contener una letra Mayúscula,Número y Carecter Especial'
      )
      .label('Contraseña'),
    Confirm: Yup.string()
      .oneOf([Yup.ref('Password'), null], 'Las contraseñas no  coinciden')
      .required('Campo Obligatorio'),
    PIN: Yup.string().required().min(5).max(5).label('PIN'),
  }),

  user: Yup.object().shape({
    INE: Yup.string()
      .min(18)
      .max(18)
      .matches(patternINE, 'Ingrese una Clave de Elector válida')
      .required()
      .label('Clave de Elector'),
    VigenciaINE: Yup.number().required().typeError('Ingrese una Vigencia INE válida').label('Vigencia INE'),
    SeccionVota: Yup.number().required().min(1).max(3900).label('Sección Vota'),

    Nombre: Yup.string().required().min(3).label('Nombre'),
    Paterno: Yup.string().required().min(2).label('Apellido Paterno'),
    Materno: Yup.string().required().min(2).label('Apellido Materno'),
    FechaNacimiento: Yup.date()
      .required()
      .label('Fecha de nacimiento')
      .typeError('Ingrese una Clave de Elector válida'),
    idSexo: Yup.number().required().label('Sexo').typeError('Ingrese una Clave de Elector válida'),
    idEstadoNacimiento: Yup.number()
      .required()
      .label('Estado de nacimiento')
      .typeError('Ingrese una Clave de Elector válida'),
  }),

  contact: Yup.object().shape({
    Celular: Yup.string().phone().min(10).max(10).required().label('Celular'),
    Telefono: Yup.string().phone().min(10).max(10).optional().nullable().label('Telefono'),
    TelMensajes: Yup.string().phone().min(10).max(10).optional().nullable().label('Telefono mensajes'),
    Correo: Yup.string().email().required().label('Correo Electronico'),
  }),

  address: Yup.object().shape({
    CalleVive: Yup.string().required().min(2).label('Calle donde vive'),
    NumExtVive: Yup.string().optional().nullable().label('No. Exterior'),
    NumIntVive: Yup.string().optional().nullable().label('No. Interior'),
    idEntidadVive: Yup.number().required().label('Estado'),
    idMunicipioVive: Yup.number().required().label('Municipio'),
    idLocalidadVive: Yup.number().required().label('Localidad'),
    ColoniaVive: Yup.string().required().min(3).label('Colonia'),
    CPVive: Yup.number()
      .required()
      .integer()
      .positive()
      .test('len', 'El código postal debe tener 5 dígitos', (val) => val && val.toString().length === 5)
      .label('El código postal'),
  }),

  social: Yup.object().shape({
    facebook: Yup.string().nullable().validUrl('Facebook'),
    instagram: Yup.string().nullable().validUrl('Instagram'),
    tiktok: Yup.string().nullable().validUrl('TikTok'),
    x: Yup.string().nullable().validUrl('X'),
  }),

  academy: Yup.object().shape({
    idGrade: Yup.number().required().min(1, 'Elige un grado').label('Último grado'),
    generalEducation: Yup.string().min(3).required().label('Formación General'),
  }),

 /*  volunteer: Yup.object().shape({
    EsVoluntario: Yup.number()
      .nullable()
      .required('Indica si participas en alguna actividad')
      .label('Participa en actividad'),

    idVoluntario: Yup.number()
      .nullable()
      .when(['EsVoluntario', 'idDeseaParticipar'], {
        is: (esVoluntario, idDeseaParticipar) =>
          Number(esVoluntario) === 1 || Number(idDeseaParticipar) === 1,
        then: (schema) =>
          schema.required('Selecciona en qué actividad participas').label('Actividad'),
        otherwise: (schema) => schema.nullable().optional(),
      }),

    idDeseaParticipar: Yup.number()
      .nullable()
      .when('EsVoluntario', {
        is: (val) => Number(val) === 0,
        then: (schema) =>
          schema.required('Indica si deseas participar en alguna actividad').label('Desea participar'),
        otherwise: (schema) => schema.nullable().optional(),
      }),
  }), */
});

export { CompromisoAddPublicSchema };
